/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
], function() {

	class ContentActionUtil {
		static getNodes(controller, idList) {
			const nodes = [];
			idList.forEach(id => {
				const layoutView = controller.layoutController.getLayoutView(id);
				if (layoutView && layoutView.domNode) {
					nodes.push(layoutView.domNode);
				}
			});
			return nodes;
		}
	}

	return ContentActionUtil;
});